import React from "react";
import { Stack, Paper, Text, Group, ActionIcon } from "@mantine/core";
import { IconCheck, IconChevronRight } from "@tabler/icons-react";
import { AVAILABLE_TEMPLATES } from "../utils/FeatureLocks";

const COLOR_BACKGROUND_WHITE = "#ffffff";
const COLOR_TEXT_BLACK = "#000000";
const COLOR_TEXT_WHITE = "#ffffff";
const COLOR_BORDER_LIGHT = "#e9ecef";
const COLOR_THEME_VIBRANT = "#ff6b6b";
const COLOR_THEME_LUXURY = "#d4af37";
const COLOR_THEME_WARM = "#2d5016";
const COLOR_THEME_ORGANIC = "#f5f5dc";

interface WebsiteGeneratorThemeOptionsProps {
  selectedTheme: string;
  onThemeSelect: (theme: string) => void;
}

const WebsiteGeneratorThemeOptions: React.FC<
  WebsiteGeneratorThemeOptionsProps
> = ({ selectedTheme, onThemeSelect }) => {
  // TODO: Add fetch themes from list of templates that are currently created
  // Commented out mocked/fake themes - only showing the default available theme
  // const templates = [
  //   {
  //     id: "website",
  //     name: "Minimalist",
  //     selected: selectedTheme === "website",
  //     available: AVAILABLE_TEMPLATES.website,
  //     content: "unlock",
  //     description: "the Unexpected.",
  //     style: {
  //       backgroundColor: COLOR_BACKGROUND_WHITE,
  //       color: COLOR_TEXT_BLACK,
  //       padding: "16px",
  //       borderRadius: "8px",
  //       border: `1px solid ${COLOR_BORDER_LIGHT}`,
  //       position: "relative",
  //     },
  //   },
  //   {
  //     id: "vibrant",
  //     name: "Vibrant",
  //     selected: selectedTheme === "vibrant",
  //     available: AVAILABLE_TEMPLATES.vibrant,
  //     content: "Your POP Story.",
  //     description: "Our Creative Vision.",
  //     style: {
  //       backgroundColor: COLOR_THEME_VIBRANT,
  //       color: COLOR_TEXT_WHITE,
  //       padding: "16px",
  //       borderRadius: "8px",
  //       border: `1px solid ${COLOR_BORDER_LIGHT}`,
  //       position: "relative",
  //     },
  //   },
  //   {
  //     id: "luxury",
  //     name: "Luxe",
  //     selected: selectedTheme === "luxury",
  //     available: AVAILABLE_TEMPLATES.luxury,
  //     content: "INSPIRING",
  //     description: "GREATNESS",
  //     style: {
  //       backgroundColor: COLOR_THEME_LUXURY,
  //       color: COLOR_TEXT_WHITE,
  //       padding: "16px",
  //       borderRadius: "8px",
  //       border: `1px solid ${COLOR_BORDER_LIGHT}`,
  //       position: "relative",
  //       textAlign: "center",
  //     },
  //   },
  //   {
  //     id: "warm",
  //     name: "Warm",
  //     selected: selectedTheme === "warm",
  //     available: AVAILABLE_TEMPLATES.warm,
  //     content: "Find Yourself",
  //     description: "Here",
  //     style: {
  //       backgroundColor: COLOR_THEME_WARM,
  //       color: COLOR_TEXT_WHITE,
  //       padding: "16px",
  //       borderRadius: "8px",
  //       border: `1px solid ${COLOR_BORDER_LIGHT}`,
  //       position: "relative",
  //     },
  //   },
  //   {
  //     id: "modern",
  //     name: "Modern",
  //     selected: selectedTheme === "modern",
  //     available: AVAILABLE_TEMPLATES.modern,
  //     content: "Modern clean",
  //     description: "website designs",
  //     style: {
  //       backgroundColor: COLOR_BACKGROUND_WHITE,
  //       color: COLOR_TEXT_BLACK,
  //       padding: "16px",
  //       borderRadius: "8px",
  //       border: `1px solid ${COLOR_BORDER_LIGHT}`,
  //       position: "relative",
  //     },
  //   },
  //   {
  //     id: "organic",
  //     name: "Organic",
  //     selected: selectedTheme === "organic",
  //     available: AVAILABLE_TEMPLATES.organic,
  //     content: "IT'S SO",
  //     description: "SIMPLE",
  //     style: {
  //       backgroundColor: COLOR_THEME_ORGANIC,
  //       color: COLOR_TEXT_BLACK,
  //       padding: "16px",
  //       borderRadius: "8px",
  //       border: `1px solid ${COLOR_BORDER_LIGHT}`,
  //       position: "relative",
  //     },
  //   },
  // ];

  // Only show the default available theme (website)
  const templates = [
    {
      id: "website",
      name: "Minimalist",
      selected: selectedTheme === "website",
      available: AVAILABLE_TEMPLATES.website,
      content: "unlock",
      description: "the Unexpected.",
      style: {
        backgroundColor: COLOR_BACKGROUND_WHITE,
        color: COLOR_TEXT_BLACK,
        padding: "16px",
        borderRadius: "8px",
        border: `1px solid ${COLOR_BORDER_LIGHT}`,
        position: "relative",
      },
    },
  ];

  return (
    <Stack gap="sm">
      {templates.map((template) => (
        <Paper
          key={template.id}
          onClick={() => template.available && onThemeSelect(template.id)}
          style={
            {
              ...template.style,
              cursor: template.available ? "pointer" : "not-allowed",
              opacity: template.available ? 1 : 0.5,
            } as React.CSSProperties
          }
        >
          {template.selected && template.available && (
            <ActionIcon
              variant="filled"
              color="blue"
              size="sm"
              style={{
                position: "absolute",
                top: "8px",
                left: "8px",
              }}
            >
              <IconCheck size={12} />
            </ActionIcon>
          )}

          <Stack gap="xs">
            <Text
              fw={700}
              size="lg"
              style={{
                color: template.style.color,
                lineHeight: 1.2,
              }}
            >
              {template.content}
            </Text>
            <Text
              size="sm"
              style={{
                color: template.style.color,
                opacity: 0.9,
                lineHeight: 1.3,
              }}
            >
              {template.description}
            </Text>
            <Text
              size="xs"
              style={{
                color: template.style.color,
                opacity: 0.7,
              }}
            >
              {template.name}
            </Text>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};

export default WebsiteGeneratorThemeOptions;
